<template>
	<div>

		<div class="head">
			<proHead></proHead>
		</div>

		<div class="proComThre">
			<div class="box">
				<!-- 左侧内容区 -->
				<div class="le">

					<div class="con wow fadeInUp">
						<div class="tle">
							<h3 class="tit-48 montserMedium B-500">{{gudingziduan.tuijian.pone3_1}}</h3>
							<span class="tit-16">{{gudingziduan.tuijian.pone3_2}}</span>
						</div>


						<div class="proInfo">

							<div class="list">

								<div class="item" v-for="(list, index) in listAll" :key="list.id">

									<div class="hide pr mb-26" v-if="list.sectValue && list.sectValue.id"
										style="position: relative;">


										<div class="tit flex j-between">
											<div class="smTit tit-18 smTit1" v-if="list.sectValue.id === -1">
												<el-input class="gonlux_shuru2" size="mini" :minlength="1"
													v-model="list.sectValue.name"></el-input>
											</div>

											<div class="smTit tit-18 smTit2" v-else>
												<el-select v-model="list.sectValue" value-key="id"
													class="proComThre_select" placeholderstyle="color:#333"
													placeholder="Choose a device..."
													@change="chvalue(list, index, $event)">
													<el-option v-for="item in options" :key="item.id" :label="item.name"
														:value="item"></el-option>
													<el-option :key="-1" label="Manually"
														:value="{ name: '', hour: 0, power: 0, id: -1 }"></el-option>
												</el-select>
											</div>
											<el-input-number class="proComThre_shuru2" v-model="list.number" :min="1"
												:max="1000" label=""></el-input-number>
										</div>


										<div class="disc flex mt-42 j-between w100">
											<div class="p gonlux tit-15 flex " style="align-items: center;">
												<span> {{gudingziduan.tuijian.pone3_4}} [W]:</span>
												<div style="" class="ml-10 mr-10">
													<el-input class="gonlux_shuru" type="number"
														v-model="list.sectValue.power" placeholder="" size="mini"
														:minlength="1" @input="handleInpute(list, index)"></el-input>
												</div>
												<span>{{gudingziduan.tuijian.pone3_5}}</span>
											</div>
											<div class="p gonlux tit-15 flex" style="align-items: center;">
												<span>{{gudingziduan.tuijian.pone3_3}} [h]:</span>
												<div style="" class="ml-10 mr-10">
													<el-input class="gonlux_shuru" type="number"
														v-model="list.sectValue.hour" placeholder="" size="mini"
														:minlength="1" @input="handleInput(list, index)"></el-input>
												</div>
												<span>hour</span>
											</div>
										</div>
										<i @click="closeItem(list)"
											class="guanbianniu guanbianniu2 iconfont icon-guanbi ys-0 t-center"></i>
									</div>



									<div class="show flex j-between mb-10" v-else style="position: relative;">
										<el-select v-model="list.sectValue" value-key="id" class="proComThre_select"
											placeholderstyle="color:#333" placeholder="Choose a device..."
											@change="chvalue(list, index, $event)">
											<el-option :key="-1" label="Manually"
												:value="{ name: '', hour: 0, power: 0, id: -1 }"></el-option>
											<el-option v-for="item in options" :key="item.id" :label="item.name"
												:value="item">
											</el-option>

										</el-select>
										<el-input-number class="proComThre_shuru" v-model="list.number" :min="1"
											:max="600" label="描述文字"></el-input-number>
										<!-- <i @click="removelist(list)">删除</i> -->
										<i @click="removelist(list)"
											class="guanbianniu guanbianniu3 iconfont icon-guanbi ys-0 t-center mt-10"></i>

									</div>
								</div>

							</div>

							<div class="flex a-center">
								<div class="btnAdd mt-30 mb-30 cur_pointer" style="" @click="addlist()">{{gudingziduan.tuijian.pone3_6}}</div>
							</div>
							<el-divider class="tuijianfenge"></el-divider>
							<div class="total flex j-between">
								<div class="all ys-33 tit-15">{{gudingziduan.tuijian.pone3_7}} :</div>
								<div class="num">
									<div class="power" style="color: #8B8B8B;"><span class="ys-33 tit-16 mr-25">{{
										powerTotal }}</span> {{gudingziduan.tuijian.pone3_8}} [W]</div>
									<div class="wh" style="color: #8B8B8B;"><span class="ys-33 tit-16 mr-25">{{
										hourTotal }} </span>{{gudingziduan.tuijian.pone3_9}} [Wh]
									</div>
								</div>
							</div>



						</div>


						<!-- 操作按钮 -->
						<div class="more">
							<div class="btn1 montserRegular tit-18" @click.stop="$dakai('/proComTwo')">
								{{ gudingziduan.xinzengde.Back }}</div>
							<div class="btn2 montserRegular tit-18" @click="tijiao">{{gudingziduan.tuijian.pone3_10}}</div>
						</div>
					</div>


				</div>
				<div class="re">
					<!-- 右侧内容区 -->

					<!-- 步骤条 -->
					<Steps :stpsActive="stpsVal"></Steps>
					<!-- 步骤条 end!!-->

					<div class="bom">
						<i class="iconfont icon-kongxinwenhao tit-26"></i>
						<div class="p1 tit-14 montserRegular mt-15 ys-28">{{gudingziduan.tuijian.pone2_4}}</div>
						<div class="p2 tit-12 mt-10 ys-6">{{gudingziduan.tuijian.pone2_5}}</div>
						<div class="bomUs" @click="tiaozhuang">{{gudingziduan.tuijian.pone2_6}}</div>
					</div>


				</div>
			</div>


		</div>
	</div>
</template>
<script>
import proHead from '../../../components/proComSystem/header.vue'
import Steps from '../../../components/proComSystem/steps.vue'

import {
	getListDevice,
	getCalc
} from '@/api/proComSystem.js'

export default {
	components: {
		proHead,
		Steps
	},
	data() {
		return {
			stpsVal: 2, // 步骤条
			options: [{ // 下拉框
				available: true,
				comparable: 0,
				createTime: "",
				delete: true,
				hour: 0,
				id: "",
				name: "",
				power: 0,
				updateTime: ""
			},],
			sectValue: '', // 选中值
			listAll: [{
				id: '',
				number: 1, //计数器

			}], // 计算器列表
			dataId: 0,
			deviceList: [],
			deviceList2: [],
			gudingziduan: {}
		}
	},
	watch: {
			'$store.state.cunyuanyan': {
			  handler(newValue, oldValue) {
				// console.log('语言已更新:', newValue);
				this.gudingziduan=this.$store.state.cunyuanyan
				// console.log(this.gudingziduan,'video')
			  },
			  deep: true // 如果 cunyuanyan 是对象，需要设置 deep 为 true
			}
		},
	created() {
		this.$store.commit('Gaiyuyan', this.$store.state.yuyan);
		this.gudingziduan=this.$store.state.cunyuanyan
	},
	mounted() {
		new this.$wow.WOW({
			live: false
		}).init()
		getListDevice().then(res => {
			if (res.code == 200) {
				this.options = res.data
			}
		})
		this.deviceList2=this.$qu("deviceList");
		console.log(this.deviceList2)
		if(this.deviceList2.length>0){
			this.listAll=[]
			for (let i in this.deviceList2) {
				this.listAll.push( //增加就push进数组一个新值
					{
						id: this.deviceList2[i].id,
						number: this.deviceList2[i].number,
						name: this.deviceList2[i].name,
						sectValue: { hour: this.deviceList2[i].hour,name: this.deviceList2[i].name, power: this.deviceList2[i].power*1000,id:this.deviceList2[i].id}
					}
				)
			}
		}
		console.log(this.listAll)
		// console.log(this.$qu('powerTypeId'))

	},
	computed: {

		// Total Power
		powerTotal() {
			return this.listAll.reduce((pre, cur) => {
				const power = cur.sectValue ? cur.sectValue.power : 0;
				const number = cur.number ? cur.number : 0;
				return (pre += power * number);
			}, 0);
		},

		// Total Consumption
		hourTotal() {
			return this.listAll.reduce((pre, cur) => {
				const hour = cur.sectValue ? cur.sectValue.hour : 0;
				const number = cur.number ? cur.number : 0;
				const power = cur.sectValue ? cur.sectValue.power : 0;
				return (pre += hour * power * number);
			}, 0);
		},
	},

	methods: {
		// 添加
		addlist(item) {
			this.listAll.push( //增加就push进数组一个新值
				{
					id: this.dataId++,
					number: 1,
					sectValue: { hour: 0, power: 0 }
				}
			)
		},

		tiaozhuang() {
			window.open('https://en.goodwe.com/contact-us')
		},
		handleInput(e, i) {
			// listAll
			// sectValue.power
			// sectValue.hou
			if (isNaN(this.listAll[i].sectValue.hour) || this.listAll[i].sectValue.hour < 0) {
				this.listAll[i].sectValue.hour = 0
			}
		},
		handleInpute(e, i) {
			if (isNaN(this.listAll[i].sectValue.power) || this.listAll[i].sectValue.power < 0) {
				this.listAll[i].sectValue.power = 0
			}
		},
		chvalue(list, index, selectedOption) {
			// 克隆选中的选项，创建新对象
			console.log(selectedOption)
			list.sectValue = {
				id: selectedOption.id,
				name: selectedOption.name,
				power: selectedOption.power,
				hour: selectedOption.hour
			};
		},
		// 删除
		removelist(item) {
			if (this.listAll.length > 1) {
				var index = this.listAll.indexOf(item)
				if (index !== -1) {
					this.listAll.splice(index, 1)
				}
			}
		},

		closeItem(item) {
			const index = this.listAll.map((m) => m.id).indexOf(item.id);
			if (index > -1) {
				this.listAll[index].sectValue = null;
			}
		},
		processListAll() {
			this.deviceList = this.listAll.map(item => {
				const { sectValue } = item;
				return {
					hour: parseInt(sectValue.hour) || 0,
					id: sectValue.id || 0,
					name: sectValue.name || "",
					number: item.number,
					power: sectValue.power / 1000 || 0,
					Totalpower: this.powerTotal,
					Totalhour: this.hourTotal
				};
			});
			this.$cun('deviceList', this.deviceList);
			setTimeout(() => {
				this.$dakai('/proComFour')

			}, 1000)
		},
		tijiao() {
			let powerTypeId = this.$qu('powerTypeId');
			if (!powerTypeId || powerTypeId == '') {
				this.$message({
					showClose: true,
					iconClass: 'el-icon-warning',
					customClass: 'my-error-message',
					dangerouslyUseHTMLString: true,
					message: 'powerTypeId is null',
					type: 'error',
					offset: '350',
					duration: 0,
					iconClass: 'el-icon-warning'
				});
			} else {

				this.processListAll();
				// console.log(this.deviceList)

				// getCalc({deviceList:this.deviceList,powerTypeId:this.$qu('powerTypeId')}).then(s={

				// })
			}
			//
		}
	},

}
</script>
<style lang="scss" scoped>
// 主体布局
.proComThre {
	position: relative;
	background: url('../../../assets/pc/proComSystem/proComTwo-bj.png') no-repeat center;
	background-size: cover;

	.box {
		min-height: 100vh;
		display: flex;
	}

	.le {
		width: 85%;

	}

	.tuijianfenge {
		margin: 0 0 .33rem 0;
	}

	.gonlux {
		color: #787878;

	}

	.re {
		width: 15%;
		background: #ececec;
	}
}

.el-input__placeholder {
	color: #333 !important;
}

::v-deep .proComThre .proComThre_select {
	width: 60%;
	color: #333 !important;

	.el-select__caret {
		color: #333 !important;
	}

	&.selected-style {
		.el-input__inner {
			background: #fff;
		}
	}
}

.guanbianniu2 {
	position: absolute;
	top: -7px;
	right: -10px;
}

.guanbianniu3 {
	// position: absolute;right: 0px;
}

::v-deep .proComThre .guanbianniu {
	width: 29px;
	height: 29px;
	background: linear-gradient(84deg, #ff785c 0%, #e70a16 100%);
	border-radius: 50%;
	line-height: 29px;
}

::v-deep .proComThre .proComThre_select .el-input__inner {
	background: linear-gradient(65deg, rgba(255, 120, 92, 0.18) 0%, rgba(231, 10, 22, 0.18) 100%);
	border-radius: 25px;
	box-shadow: 0 2px 12px 0 rgba(255, 255, 255, 1);
	border: none;
	height: 50px;
	color: #333;

	&::placeholder {
		color: #333;
	}
}

.proComThre .proComThre_shuru,
.proComThre_shuru2 {
	// width:22.7%;
	margin-left: .11rem;
	display: flex;
	align-items: center;

}

::v-deep .gonlux_shuru {
	.el-input__inner {
		background: #E6E6E6;
		border: none;
		height: 24px;
		// width:auto;
		max-width: 50px;
		// min-width: 45px;
		padding: 0 4px;
		text-align: center;
	}
}

::v-deep .gonlux_shuru2 {
	.el-input__inner {
		background: none;
		height: 50px;
		border-radius: 100px;
		// width:auto;
		max-width: 100%;
		// min-width: 45px;
		font-size: var(--font14);
		padding: 0 4px;
		text-align: center;
	}
}

.btnAdd {
	// width: 119px;
	// height: 50px;
	// border-radius: 25px;
	padding: .1rem .5rem;
	color: #fff;
	background: linear-gradient(-50deg, #e70a16 0%, #ff785c 100%);
	border-radius: 100px;
	display: inline-block;
	margin: .3rem auto;
}

::v-deep .proComThre .proComThre_shuru2 {
	.el-input__inner {
		background: #DDDDDD;
		height: 50px;
		border-radius: 100px;
	}

	.el-input-number__decrease,
	.el-input-number__increase {
		width: 31px;
		height: 31px;
		line-height: 31px;
		background: #fdfdfd;
		border-radius: 16px;
		border: none;
		top: 50%;
		transform: translateY(-50%);
	}

	.el-input-number__decrease {
		margin-left: 5px;
	}

	.el-input-number__increase {
		margin-right: 5px;
	}
}

::v-deep .proComThre .proComThre_shuru {
	width: 120px;

	.el-input__inner {
		background: #DDDDDD;
		height: 50px;
		border-radius: 25px;
	}

	.el-input-number__decrease,
	.el-input-number__increase {
		width: 38px;
		height: 38px;
		line-height: 38px;
		background: #fdfdfd;
		border-radius: 19px;
		border: none;
		margin-top: 4px;
	}

	.el-input-number__decrease {
		margin-left: 5px;
	}

	.el-input-number__increase {
		margin-right: 5px;
	}
}

// 内容区左侧
.proComThre .le {
	box-sizing: border-box;
	padding: 1rem 10%;
	display: flex;
	align-items: center;
	justify-content: center;

	.con {
		width: 100%;

		.tle {
			text-align: center;

			h3 {}

			span {
				display: block;
				margin-top: .1rem;
			}
		}



	}

	::v-deep .proInfo {
		width: 48%;
		margin: auto;
		padding: .3rem;
		margin-top: .3rem;
		box-sizing: border-box;
		background: linear-gradient(41deg, #ffffff 0%, #dbdbdb 100%);
		border-radius: 0.3rem;
		box-shadow: 0.05rem 0.09rem 0.16rem 0.1rem rgba(0, 0, 0, 0.02);

		.hide {
			padding: .2rem;
			background: #fdfdfd;
			border-radius: 0.15rem;

			.smTit {
				width: 60%;
			}

			.proComThre_select {
				width: 100%;
			}

			.proComThre_select .el-input__inner {
				background: #fff;
				border: 1px solid #ddd;
			}
		}
	}


}





// 内容区右侧
.proComThre .re {
	padding: 0 .3rem;
	padding-right: .2rem;
	padding-top: 2rem;
	box-sizing: border-box;
	min-width: 200px;

	.bom {
		position: absolute;
		bottom: 5%;

		i {
			color: #E60012;
		}

		.p1 {
			color: #282828;
		}

		.bomUs {
			cursor: pointer;
			margin-top: .2rem;
			display: inline-block;
			background: #f9fafb;
			border: 1px solid #d1d5dc;
			font-family: "montserRegular";
			border-radius: 50px;
			font-size: 12px;
			padding: .11rem;
			transition: .5s;

			&:hover {
				background: #E60012;
				color: #fff;
				border-color: #E60012;
			}
		}

	}
}

// 底部按钮

.more {
	display: flex;
	justify-content: center;
	margin-top: .9rem;

	>div {
		cursor: pointer;
		transition: .5s;
		border-radius: 50px;
	}

	.btn1 {
		padding: .16rem .48rem;
		border: 1px solid #bebebe;
		color: #333;
		margin-right: .2rem;

		&:hover {
			background: #e70a16;
			border-color: #e70a16;
			color: #fff;
		}
	}

	.btn2 {
		padding: .16rem .35rem;
		background: linear-gradient(-71deg, #e70a16 0%, #ff785c 100%);
		color: #fff;

		&:hover {
			box-shadow: 0 0 .1rem #e70a16;
		}
	}
}

@media screen and (max-width:1403px) {
	.disc {
		flex-wrap: wrap;
	}

	.gonlux {
		width: 100%;
		margin-bottom: .1rem;
	}
}


// ==========================================================================================================================================================================
// 响应式

@media screen and (max-width:1300px) {
	.proComThre .le .proInfo {
		width: 65%;
	}

}

@media screen and (max-width:991px) {
	.proComThre .le .proInfo {
		width: 100%;
	}
}

@media screen and (max-width:767px) {
	.proConHead {
		background: #f9fafb;
	}

	.proComThre .le {
		width: 100%;
		padding: 1rem 5%;
	}

	.proComThre .re {
		display: none;
	}

	.proComThre .le .proInfo .list .item {
		margin-bottom: .3rem;
	}

	.proComThre .le .proInfo .list .item .show {
		flex-wrap: wrap;
		justify-content: flex-start;
		align-items: center;
	}

	.proComThre .le .proInfo .list .item .show .proComThre_select {
		width: 100%;
		margin-bottom: .3rem;
	}

	.proComThre .le .proInfo .list .item .show .guanbianniu {
		margin-top: 0;
		margin-left: .3rem;
	}

	.proComThre .le .proInfo .hide .tit {
		flex-wrap: wrap;
	}

	.proComThre .le .proInfo .hide .smTit {
		width: 100%;
		margin-bottom: .3rem;
	}

	.proComThre .le .proInfo .hide .proComThre_shuru2 {
		width: 120px;
	}
}
</style>